var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('fragment',_vm._l((_vm.sites),function(site,sidx){return _c('site-list-item',{key:'site-' + sidx,attrs:{"name":site.name,"hives":site.hives}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }